import Connect from './Connect/Connect';
import CreateUser from './CreateUser/CreateUser';
import Disconnect from './Disconnect/Disconnect';
import DisableUser from './DisableUser/DisableUser'
import EnableUser from './EnableUser/EnableUser';
import DeleteUser from './DeleteUser/DeleteUser';
import UpdateUser from './UpdateUser/UpdateUser'
import RemoveUserFromGroup from './RemoveUserFromGroup/RemoveUserFromGroup';
import AddUserToGroup from './AddUserToGroup/AddUserToGroup';
import MoveUser from './MoveUser/MoveUser';
import UnlockUser from './UnlockUser/UnlockUser';
import AddGroup from './AddGroup/AddGroup';
import LdapQuery from './LdapQuery/LdapQuery';
import PasswordReset from './PasswordReset/PasswordReset';
import { types } from './types';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Param       showAlert -  show alert
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Actions(action, showAlert, variables, setOpenVariable, variableRender, automId, automVersionId) {
    switch (action.actionName) {
        case types.CONNECT:
            return <Connect automId={automId} action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} automVersionId={automVersionId} />;
        case types.CREATEUSER:
            return <CreateUser action={action} variables={variables} setOpenVariable={setOpenVariable} />;
        case types.DISCONNECT:
            return <Disconnect action={action} />;
        case types.DISABLEUSER:
            return <DisableUser action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        case types.ENABLEUSER:
            return <EnableUser action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        case types.DELETEUSER:
            return <DeleteUser action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        case types.UPDATEUSER:
            return <UpdateUser action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        case types.REMOVEUSERFROMGROUP:
            return <RemoveUserFromGroup action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender}
                automVersionId={automVersionId} />;
        case types.ADDUSERTOGROUP:
            return <AddUserToGroup action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender}
                automVersionId={automVersionId} />;
        case types.MOVEUSER:
            return <MoveUser action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} automId={automId} />;
        case types.UNLOCKUSER:
            return <UnlockUser action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} automId={automId} />;
        case types.ADDGROUP:
            return <AddGroup action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        case types.LDAP:
            return <LdapQuery action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        case types.PASSWORD:
            return <PasswordReset action={action} showAlert={showAlert} variables={variables}
                setOpenVariable={setOpenVariable} variableRender={variableRender} />;
        default:
            break;
    }
}

export default Actions;
